(() => {
  const STORAGE_KEY = 'allure_fitment_vehicle';
  const sections = document.querySelectorAll('[data-fitment]');
  if (!sections.length) return;

  const norm = (s) => String(s || '').trim().toLowerCase();
  const dedupe = (arr) => Array.from(new Set(arr.filter(Boolean)));

  const parseYears = (raw) => {
    if (!raw) return null;
    const cleaned = String(raw).replace(/[^\d\-–]/g, '');
    const parts = cleaned.split(/[-–]/).map((p) => parseInt(p, 10)).filter((n) => !isNaN(n));
    if (parts.length === 0) return null;
    if (parts.length === 1) return [parts[0], parts[0]];
    return [Math.min(parts[0], parts[1]), Math.max(parts[0], parts[1])];
  };

  const matchVehicle = (user, vehicles) => {
    const exact = vehicles.find((v) => {
      if (norm(v.brand) !== norm(user.brand)) return false;
      if (norm(v.model) !== norm(user.model)) return false;
      const range = parseYears(v.years);
      if (!range) return true;
      const yearNum = parseInt(user.year, 10);
      if (isNaN(yearNum)) return true;
      return yearNum >= range[0] && yearNum <= range[1];
    });
    if (exact) return { type: 'exact', vehicle: exact };

    const sameModel = vehicles.filter(
      (v) => norm(v.brand) === norm(user.brand) && norm(v.model) === norm(user.model)
    );
    if (sameModel.length > 0) {
      const ranges = sameModel.map((v) => parseYears(v.years)).filter(Boolean);
      const yearsLabel = ranges
        .map((r) => (r[0] === r[1] ? String(r[0]) : `${r[0]}-${r[1]}`))
        .join(', ');
      return { type: 'wrong-year', model: sameModel[0], yearsLabel };
    }

    return { type: 'none' };
  };

  const ICONS = {
    ok: '<svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    warn: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>',
  };

  const buildWA = (phone, productTitle, vehicleStr, productHandle) => {
    if (!phone) return '';
    const url = `https://${location.host}/products/${productHandle}`;
    const msg = `Hola, quiero verificar si este repuesto es compatible con mi vehículo:\n\n*Repuesto:* ${productTitle}\n*Vehículo:* ${vehicleStr}\n${url}`;
    return `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`;
  };

  const renderResult = (container, type, title, detail, ctaUrl, ctaLabel) => {
    const cta = ctaUrl
      ? `<a href="${ctaUrl}" target="_blank" rel="noopener" class="fitment-result__cta">${ICONS.wa}${ctaLabel || 'Confirmar por WhatsApp'}</a>`
      : '';
    container.className = `fitment-result fitment-result--${type}`;
    container.innerHTML = `
      <div class="fitment-result__head">${ICONS[type] || ''}<span>${title}</span></div>
      ${detail ? `<p class="fitment-result__detail">${detail}</p>` : ''}
      ${cta}
    `;
    container.hidden = false;
  };

  const loadSaved = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.brand || !parsed.model || !parsed.year) return null;
      return parsed;
    } catch (e) { return null; }
  };

  const saveVehicle = (vehicle) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle)); } catch (e) {}
  };

  const initSection = (section) => {
    const db = window.AllureVehicleDB;
    if (!db || !Array.isArray(db.brands)) {
      console.warn('AllureVehicleDB no disponible');
      return;
    }

    const vehiclesScript = section.querySelector('[data-fitment-vehicles]');
    let vehicles = [];
    try {
      vehicles = JSON.parse((vehiclesScript?.textContent || '[]').trim() || '[]');
    } catch (e) { vehicles = []; }

    const whatsapp = section.dataset.whatsapp || '';
    const productTitle = section.dataset.productTitle || '';
    const productHandle = section.dataset.productHandle || '';

    const form = section.querySelector('[data-fitment-form]');
    const result = section.querySelector('[data-fitment-result]');
    const submitBtn = section.querySelector('[data-fitment-submit]');
    const brandSel = section.querySelector('[data-fitment-brand]');
    const modelSel = section.querySelector('[data-fitment-model]');
    const yearSel = section.querySelector('[data-fitment-year]');
    const helpBtn = section.querySelector('[data-fitment-help]');
    const savedBox = section.querySelector('[data-fitment-saved]');
    const savedLabel = section.querySelector('[data-fitment-saved-label]');
    const changeBtn = section.querySelector('[data-fitment-change]');

    if (!form || !brandSel || !modelSel || !yearSel || !submitBtn) return;

    const brandIndex = {};
    db.brands.forEach((b) => { brandIndex[norm(b.name)] = b; });

    // Populate brands
    db.brands
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name))
      .forEach((b) => {
        const opt = document.createElement('option');
        opt.value = b.name;
        opt.textContent = b.name;
        brandSel.appendChild(opt);
      });

    const updateFilledState = () => {
      [brandSel, modelSel, yearSel].forEach((sel) => {
        sel.classList.toggle('is-filled', !!sel.value);
      });
      submitBtn.disabled = !(brandSel.value && modelSel.value && yearSel.value);
    };

    const populateModels = () => {
      modelSel.innerHTML = '<option value="">Selecciona</option>';
      yearSel.innerHTML = '<option value="">Selecciona</option>';
      const brand = brandSel.value;
      if (!brand) {
        modelSel.disabled = true;
        yearSel.disabled = true;
        updateFilledState();
        return;
      }
      const brandObj = brandIndex[norm(brand)];
      const models = brandObj && Array.isArray(brandObj.models) ? brandObj.models.slice().sort() : [];
      models.forEach((m) => {
        const opt = document.createElement('option');
        opt.value = m;
        opt.textContent = m;
        modelSel.appendChild(opt);
      });
      modelSel.disabled = models.length === 0;
      yearSel.disabled = true;
      updateFilledState();
    };

    const populateYears = () => {
      yearSel.innerHTML = '<option value="">Selecciona</option>';
      const brand = brandSel.value;
      const model = modelSel.value;
      if (!brand || !model) {
        yearSel.disabled = true;
        updateFilledState();
        return;
      }
      const [yFrom, yTo] = db.yearRange || [1990, new Date().getFullYear()];
      for (let y = yTo; y >= yFrom; y--) {
        const opt = document.createElement('option');
        opt.value = String(y);
        opt.textContent = String(y);
        yearSel.appendChild(opt);
      }
      yearSel.disabled = false;
      updateFilledState();
    };

    brandSel.addEventListener('change', populateModels);
    modelSel.addEventListener('change', populateYears);
    yearSel.addEventListener('change', updateFilledState);

    const showSavedChip = (vehicleStr) => {
      if (!savedBox || !savedLabel) return;
      savedLabel.textContent = vehicleStr;
      savedBox.hidden = false;
    };
    const hideSavedChip = () => { if (savedBox) savedBox.hidden = true; };

    const restoreSaved = () => {
      const saved = loadSaved();
      if (!saved) return;
      const brandObj = brandIndex[norm(saved.brand)];
      if (!brandObj) return;
      brandSel.value = brandObj.name;
      populateModels();
      const modelOption = Array.from(modelSel.options).find((o) => norm(o.value) === norm(saved.model));
      if (!modelOption) { updateFilledState(); return; }
      modelSel.value = modelOption.value;
      populateYears();
      const yearOption = Array.from(yearSel.options).find((o) => o.value === String(saved.year));
      if (yearOption) yearSel.value = yearOption.value;
      updateFilledState();
      const userVehicle = { brand: brandSel.value, model: modelSel.value, year: yearSel.value };
      if (userVehicle.brand && userVehicle.model && userVehicle.year && vehicles.length) {
        const m = matchVehicle(userVehicle, vehicles);
        if (m.type === 'exact') {
          showSavedChip(`${userVehicle.brand} ${userVehicle.model} ${userVehicle.year}`);
        }
      }
    };

    changeBtn?.addEventListener('click', () => {
      hideSavedChip();
      result.hidden = true;
      brandSel.value = '';
      populateModels();
      brandSel.focus();
    });

    helpBtn?.addEventListener('click', () => {
      const partial = [brandSel.value, modelSel.value, yearSel.value].filter(Boolean).join(' ') || 'no encuentro mi vehículo en la lista';
      const wa = buildWA(whatsapp, productTitle, partial, productHandle);
      if (wa) window.open(wa, '_blank', 'noopener');
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const user = { brand: brandSel.value, model: modelSel.value, year: yearSel.value };
      if (!user.brand || !user.model || !user.year) {
        renderResult(result, 'warn', 'Faltan datos', 'Selecciona marca, modelo y año.');
        return;
      }

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;

      setTimeout(() => {
        const label = `${user.brand} ${user.model} ${user.year}`;
        const m = vehicles.length ? matchVehicle(user, vehicles) : { type: 'none' };

        if (m.type === 'exact') {
          let detail = `Compatible con tu ${label}.`;
          if (m.vehicle.engine) detail += ` Motor ${m.vehicle.engine}.`;
          if (m.vehicle.fuel) detail += ` ${m.vehicle.fuel}.`;
          renderResult(result, 'ok', '¡Compatible con tu vehículo!', detail);
          saveVehicle(user);
          showSavedChip(label);
        } else if (m.type === 'wrong-year') {
          const wa = buildWA(whatsapp, productTitle, label, productHandle);
          renderResult(
            result,
            'warn',
            `Tu ${user.brand} ${user.model} sí, pero el año ${user.year} no está confirmado`,
            `Este repuesto está confirmado para los años ${m.yearsLabel}. Si quieres verificar para el año ${user.year}, escríbenos con tu número de chasis.`,
            wa,
            'Verificar por WhatsApp'
          );
          saveVehicle(user);
        } else {
          const wa = buildWA(whatsapp, productTitle, label, productHandle);
          renderResult(
            result,
            'warn',
            'No verificado para tu vehículo',
            'Este repuesto no está confirmado para tu modelo. Confírmalo con nosotros antes de comprar — te respondemos en minutos.',
            wa,
            'Consultar por WhatsApp'
          );
          saveVehicle(user);
        }

        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
      }, 350);
    });

    restoreSaved();
  };

  // Wait for vehicle-database.js to load (it's defer'd before this script)
  const readyCheck = () => {
    if (window.AllureVehicleDB) {
      sections.forEach(initSection);
    } else {
      setTimeout(readyCheck, 50);
    }
  };
  readyCheck();
})();
